export  class  User {
  email: string;
  userId: string;
  firstName: string;
  lastName: string;
  retailerName: string;
  role: string;
  retailerID: string;
  storeID: string;
  storeName: string;
  location: string;
  isCompRxtEnabled: boolean;
  isRemoveEnabled: boolean;
  isAutoShutdown?: boolean;
  customSrtEnabled?: boolean;
  configurations?: string; // Adding configurations object to appGlobal when user role is retailHQ
  partnerID?: string;   //Adding configurations object to appGlobal when user role is author
  partnerName?: string;   //Adding configurations object to appGlobal when user role is author

  constructor(userId?: string, email?: string, firstName?: string, lastName?: string, retailerName?: string, role?: string, retailerID?: string, storeID?: string, storeName?: string, location?: string, partnerID?: string, partnerName?: string) {
    this.email = email;
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.retailerName = retailerName;
    this.role = role;
    this.retailerID = retailerID;
    this.storeID = storeID;
    this.storeName = storeName;
    this.location = location;
    this.partnerID = partnerID;
    this.partnerName = partnerName;
  }

}
